export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="text-center">
        <div className="inline-flex items-center gap-3 mb-4">
          <div className="w-10 h-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
        </div>
        <div className="flex items-center justify-center gap-2 mb-1">
          <span className="text-lg font-bold text-white tracking-widest">SENTINEL</span>
          <span className="text-lg font-light text-emerald-400 tracking-widest">RESPONSE</span>
          <span className="text-[8px] text-gray-500">™</span>
        </div>
        <p className="text-sm text-gray-500">Loading platform...</p>
      </div>
    </div>
  );
}
